import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../base/base.service';

/** Tarea propuesta por el agente para agregar al cómputo. */
export interface AssistantProposedTask {
  task_id: number;
  tarea: string;
  etapa: string | null;
  unidad: string | null;
  quantity: number | null;
  reason: string;
  costo_total_unitario: number;
}

/** Opción clickeable de una repregunta. */
export interface AssistantQuestionOption {
  label: string;
  value: string;
  hint: string | null;
}

/** Propuesta de tareas para agregar al cómputo. */
export interface AssistantAddTasksAction {
  action: 'add_tasks';
  tasks: AssistantProposedTask[];
  descartadas_por_id_inexistente: number[];
}

/** Repregunta con opciones, para elegir con un clic en vez de tipear. */
export interface AssistantAskOptionsAction {
  action: 'ask_options';
  question: string;
  options: AssistantQuestionOption[];
  allow_free_text: boolean;
}

/** Acción sugerida por el agente. El usuario la resuelve desde la pantalla. */
export type AssistantAction = AssistantAddTasksAction | AssistantAskOptionsAction;

export interface AssistantUsage {
  used_today: number;
  used_month: number;
  daily_limit: number;
  monthly_limit: number;
  remaining_today: number;
  remaining_month: number;
}

export interface AssistantChatResponse {
  session_id: number;
  reply: string;
  actions: AssistantAction[];
  usage: AssistantUsage;
}

export interface AssistantChatSession {
  id: number;
  title: string | null;
  last_message_at: string | null;
}

export interface AssistantStoredMessage {
  id: number;
  role: 'user' | 'assistant';
  content: string;
  actions: AssistantAction[] | null;
  created_at: string;
}

/** Error 429 del backend cuando se agotó el cupo. */
export interface AssistantLimitError {
  message: 'ai_limit_reached';
  scope: 'daily' | 'monthly';
  resets_at: string;
  usage: AssistantUsage;
}

@Injectable({
  providedIn: 'root'
})
export class AssistantChatService extends BaseService {

  ask(message: string, sessionId?: number | null): Observable<AssistantChatResponse> {
    return this.httpPost('ai/chat', {
      message,
      session_id: sessionId ?? null,
    });
  }

  getSessions(): Observable<AssistantChatSession[]> {
    return this.httpGet('ai/chat/sessions');
  }

  getMessages(sessionId: number): Observable<{ session_id: number; messages: AssistantStoredMessage[] }> {
    return this.httpGet(`ai/chat/sessions/${sessionId}/messages`);
  }

  getUsage(): Observable<AssistantUsage> {
    return this.httpGet('ai/chat/usage');
  }
}
